module.exports = __webpack_public_path__ + "assets/img/bg-fail.a8bd252d.png";